import { IRiskStakeholderEditItem, RiskStakeholderEditItem } from "./riskStakeholderEditItem";

export interface IRiskStakeholderEdit {
    item: IRiskStakeholderEditItem;
}

export class RiskStakeholderEdit implements IRiskStakeholderEdit {
    item: RiskStakeholderEditItem;

    constructor();
    constructor(obj: IRiskStakeholderEdit);
    constructor(obj?: any) {
        this.item = new RiskStakeholderEditItem(obj ? obj.item : null);
    }
}